import {PureComponent} from 'react'

import LandingFreelance from './LandingFreelanceUniverse.jsx'

import header from './images/header-engineering.png?size=600'

const metaDescription = "Accédez à des missions pour ingénieur: méthode, industrialisation, qualité, process, R&D... Un accompagnement personnalisé et des projets adaptés à votre expertise."
const metaTitle = "Twineeds | Missions ingénierie | Consultants indépendants"

export default class LandingFreelanceEngineering extends PureComponent {
  render() {
    const headerBrief = <p>Vous êtes <strong>expert en ingénierie</strong> ? Accédez à des <strong>missions techniques partout en France</strong>, en lien direct avec vos expertises. Rencontrez Twineeds pour vous lancer dans des projets qui vous correspondent.</p>

    return (
      <LandingFreelance
        headerImg={header.src}
        headerImgAlt="PC et portable montrant un site d'intermédiation pour consultants freelances et entreprise"
        headerBrief={headerBrief}
        metaDescription={metaDescription}
        metaOgDescription={metaDescription}
        metaTitle={metaTitle}
        metaOgTitle={metaTitle}
        sectorText="de l'ingénierie"
        title="Consultants ingénieurs : accédez à des missions"
        universeCode="engineering"
      />
    )
  }
}
